export const ShipmentModes = [ 'road', 'air', 'ocean' ] as const;
export type ShipmentModes = typeof ShipmentModes[number];
